/** @format */

import axios from 'axios';
import { REALM_NAME, CLIENT_NAME } from '../../Constants/commons';
import { getAuthToken } from '../../Util/authUtils';

export const keycloakAxios = axios.create({
  baseURL: process.env.REACT_APP_KEYCLOAK,
});

keycloakAxios.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) config.headers.Authorization = token;
  return config;
});

const FORM_HEADERS = {
  'Content-Type': 'application/x-www-form-urlencoded',
};

export const forgotPassword = async ({ email, redirectUrl }) => {
  const payload = new URLSearchParams();
  payload.append('realm', REALM_NAME);
  payload.append('clientName', CLIENT_NAME);
  payload.append('email', email);
  payload.append('redirectUrl', redirectUrl);
  const response = await keycloakAxios.post(
    '/api/users/auth/forgotPassword',
    payload,
    { headers: FORM_HEADERS }
  );
  return response.data;
};

export const resetForgotPassword = async ({
  newPassword,
  confirmPassword,
  resetToken,
}) => {
  const payload = new URLSearchParams();
  payload.append('realm', REALM_NAME);
  payload.append('clientName', CLIENT_NAME);
  payload.append('newPassword', newPassword);
  payload.append('confirmPassword', confirmPassword);
  payload.append('resetToken', resetToken);
  const response = await keycloakAxios.post(
    '/api/users/auth/forgot/resetPassword',
    payload,
    { headers: FORM_HEADERS }
  );
  return response.data;
};

export const resetUserPassword = async (userId, newPassword) => {
  const payload = new URLSearchParams();
  payload.append('realm', REALM_NAME);
  payload.append('userId', userId);
  payload.append('newPassword', newPassword);
  payload.append('clientId', CLIENT_NAME);
  await keycloakAxios.post('/api/users/resetUserPassword', payload, {
    headers: FORM_HEADERS,
  });
};

export const userLoginKeycloak = async (payload) => {
  const { data } = await keycloakAxios.post('/api/users/login', payload);
  return data;
};
